export default {
  login: {
    en: 'Login',
  },
}
